import React from 'react';
/**
 * `PageHeader` renders a standard page heading block.
 *
 * Behaviour:
 * - Renders the title as `<h1>` for all pages.
 * - Applies landing-page-specific CSS classes when `isRenewalLandingPage` is true.
 * - Renders `description` as HTML via `dangerouslySetInnerHTML`.
 * - Optionally renders informational/warning callouts.
 */

import Callout from '../sitePages/Callout';

type PageHeaderProps = {
  title: string;
  description: string;
  information?: string;
  warning?: string;
  descriptionClass?: string;
  isRenewalLandingPage?: boolean;
};

const PageHeader = ({
  title,
  description,
  descriptionClass,
  information,
  warning,
  isRenewalLandingPage
}: PageHeaderProps): JSX.Element => {
  const getTitle = (isRenewalTitlePage: boolean) => {
    return isRenewalTitlePage ? (
      <h1 data-testid='page-title' className='m2-bottom lp-header cms'>
        {title}
      </h1>
    ) : (
      <h1 data-testid='page-title' className='cms'>
        {title}
      </h1>
    );
  };

  return (
    <>
      {getTitle(isRenewalLandingPage ?? false)}
      <p
        data-testid='page-description'
        className={`m1-bottom cms ${descriptionClass}`}>
        <span dangerouslySetInnerHTML={{ __html: description }} />
      </p>
      {information && <Callout text={information} />}
      {warning && <Callout text={warning} isWarning={true} />}
    </>
  );
};

export default PageHeader;
